module.exports = __webpack_public_path__ + "img/upside_no_content.cc768ad3.png";